<template>
  <!-- FOOTER -->
  <div id="footer" class="container-fluid">
    <div class="row">
      <div class="col-md-4 col-xs-4">
        <p class="text-left">
          <router-link :to="{name:'about'}" title="About GroTec">About</router-link>
        </p>
      </div>
      <div class="col-md-4 col-xs-4">
        <p class="text-center">
          <router-link :to="{name:'contact'}" title="Contact Us">Contact</router-link>
        </p>
      </div>
      <div class="col-xs-4 col-md-4">
        <p class="text-right">
          <router-link :to="{name:'payments-privacy-terms'}" title="Privacy &amp; Terms">Terms</router-link><br>
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <p class="text-center">
          <i class="fa fa-phone"></i>
          <a href="tel:01706750293" title="Telephone">01706 750 293</a>
        </p>
        <p class="text-center">
          <i class="fa fa-envelope"></i>
          <a href="mailto:info@grotec.co.uk" title="Email">info@grotec.co.uk</a>
        </p>
      </div>
    </div>
  </div>

</template>
<script>
  export default {
    name:'grotec-footer'
  }
</script>